<onsip-animation [loop]="true" filename="error_cropped"></onsip-animation>
<h2 mat-dialog-title>{{ "ONSIP_I18N.UH_OH" | translate }}</h2>
<div mat-dialog-content>
  <p>{{ "ONSIP_I18N.IT_LOOKS_LIKE_YOUR_BROWSER_IS_TOO_SMALL_TO_VIEW_THIS_SCREEN" | translate }}</p>
  <mat-divider onsip-dotted-divider></mat-divider>
  <p>{{ "ONSIP_I18N.PLEASE_RESIZE_YOUR_WINDOW_TO_AT_LEAST_960PX_WIDE_TO_CONTINUE" | translate }}</p>
</div>
